import { Modal, Typography } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import type { ContractReviewMessage } from "../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { OFFER_REVIEW_CONTRACT_REVIEW_INTRO_COPY } from "constants/contractReviewNonBlockingCopy";
import { ContractReviewIssuesList } from "components/atoms/ContractReviewIssuesList";

type OfferReviewContractReviewIssuesModalProps = {
  open: boolean;
  messages: ContractReviewMessage[];
  onClose: () => void;
  onGoToConfirmInfo: () => void;
};

const OfferReviewContractReviewIssuesModal = ({
  open,
  messages,
  onClose,
  onGoToConfirmInfo,
}: OfferReviewContractReviewIssuesModalProps) => {
  if (!open || messages.length === 0) {
    return null;
  }

  const count = messages.length;
  const title = count === 1 ? "1 item to review" : `${count} items to review`;

  return (
    <Modal
      testId="offer-review-contract-review-issues-modal"
      type="info"
      title={title}
      onClose={onClose}
      primaryButton={{
        text: "Go to Confirm Info",
        onClick: onGoToConfirmInfo,
      }}
    >
      <BodyStack>
        <Typography color="text.secondary">
          {OFFER_REVIEW_CONTRACT_REVIEW_INTRO_COPY}
        </Typography>
        <ContractReviewIssuesList messages={messages} />
      </BodyStack>
    </Modal>
  );
};

const BodyStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export { OfferReviewContractReviewIssuesModal };
export type { OfferReviewContractReviewIssuesModalProps };
